module.exports = __webpack_public_path__ + "static/media/rj_result_scooter2.38d941ff.png";